<template>
  <div id="table-data">
    <h2>{{ table }} Values</h2>
    <table>
      <thead>
        <tr>
          <th v-for="col in cols" :key="col">{{ col }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="row in rows" :key="JSON.stringify(row)">
          <td v-for="col in cols" :key="col">{{ row[col] }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
  import _ from 'lodash'
  import {mapGetters} from 'vuex'

  export default {
    props: [ 'table' ],
    data: function () {
      return {
        rows: [],
        cols: []
      }
    },
    computed: mapGetters({
      ddb: 'getDynamoDB',
      amazonAuthenticated: 'amazonAuthenticated'
    }),
    watch: {
      ddb: function () { this.fillTable() }
    },
    methods: {
      fillTable: function () {
        if (!this.ddb || !this.table) return
        var self = this

        this.ddb.scan({TableName: this.table}, function (err, data) {
          if (err) {
            console.log(err, err.stack) // an error occurred
          } else {
            self.rows = data.Items
            self.cols = _.chain(self.rows).map(_.keys).uniq().value()[0]
          }
        })
      }
    },
    mounted: function () {
      if (!this.amazonAuthenticated) {
        this.$router.push('/unlock-secret')
        return
      }

      this.fillTable()
    }
  }
</script>
<style lang="less">
  #table-list ul {
    text-align: left;
  }
</style>


// WEBPACK FOOTER //
// src/components/Table.vue